/*  eslint no-param-reassign: ["error", { "props": false }]*/

import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import {
  Form,
  Grid,
} from 'semantic-ui-react';
import { required } from '@mhub/web-validations';
import AppForm from '../../components/AppForm';

export default class DocumentForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    file: PropTypes.shape({
      name: PropTypes.string,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static defaultValues = {
    name: '',
    tags: [],
  }
  constructor(props) {
    super(props);
    const file = Object.assign({}, DocumentForm.defaultValues, props.file || {});
    this.state = {
      file,
      oriFile: clone(file),
      options: file.tags ? file.tags.map((value, idx) => {
        const d = { key: idx, text: value, value };
        return d;
      }) : [],
      errMessages: [],
    };
    this.validation = {
      name: createRef(),
      tags: createRef(),
    };
  }
  componentWillReceiveProps(nextProps) {
    let file = Object.assign({}, DocumentForm.defaultValues, this.state.file);
    let oriFile = this.state.oriFile;
    if (JSON.stringify(this.props.file) !== JSON.stringify(nextProps.file)) {
      file = Object.assign(file, nextProps.file);
      oriFile = clone(file);
    }
    this.setState({
      file,
      oriFile,
      options: file.tags ? file.tags.map((value, idx) => {
        const d = { key: idx, text: value, value };
        return d;
      }) : [],
    });
  }
  submit(url, opts) {
    return this.form.submit(url, opts);
  }
  handleSubmit = (event) => {
    event.preventDefault();
    const { file } = this.state;
    AppForm.validate(this.validation, file)
      .then((validations) => {
        this.props.onSubmit(validations, file);
      });
  }
  handleCheckChanges() {
    if (this.props.onChange) {
      this.props.onChange(true);
    }
  }
  handleInputChange = (event, data) => {
    const { file } = this.state;
    file[data.name] = data.value;
    this.setState({ file }, () => {
      this.handleCheckChanges();
    });
  }
  handleAddition = (e, { value }) => {
    this.setState({
      options: [{ text: value, value }, ...this.state.options],
    });
  }
  render() {
    return (
      <AppForm
        onSubmit={this.handleSubmit}
        error={this.state.errMessages.length > 0}
        ref={(ref) => { this.form = ref; }}
      >
        <Grid columns="equal" stackable doubling>
          <Grid.Row>
            <Grid.Column>
              <AppForm.Input
                label="Name"
                name="name"
                value={this.state.file.name}
                onChange={this.handleInputChange}
                ref={this.validation.name}
                validation={[required]}
              />
              <AppForm.Validate
                ref={this.validation.tags}
                onChange={this.handleInputChange}
              >
                <Form.Select
                  label="Tags"
                  name="tags"
                  fluid
                  placeholder="Add tags"
                  noResultsMessage="Add tags"
                  search
                  selection
                  multiple
                  allowAdditions
                  options={this.state.options}
                  value={this.state.file.tags || []}
                  onAddItem={this.handleAddition}
                />
              </AppForm.Validate>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </AppForm>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Document/Form.jsx